"use strict";

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _Array$from = require("@babel/runtime-corejs3/core-js/array/from");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/slice");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useUser = useUser;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _react = _interopRequireDefault(require("react"));

var _createGlobalState = _interopRequireDefault(require("react-use/lib/factory/createGlobalState"));

var _useMount = _interopRequireDefault(require("react-use/lib/useMount"));

var _fetcher = require("../../fetcher");

var _url = require("../../url");

var _apiError = require("../fetcher/api-error");

var _login = require("../login");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { _Object$defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof _Symbol !== "undefined" && _getIteratorMethod(arr) || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if ((0, _isArray.default)(arr)) return arr; }

var isUserRequested = false;
var useGlobalUser = (0, _createGlobalState.default)(null);

var getUserInfo = function getUserInfo() {
  return (0, _fetcher.getFetch)({
    url: "".concat(_url.MISSEVAN_API_PREFIX_URL, "/account/userinfo")
  }, {
    isLoginRedirect: false
  });
};

function useUser() {
  var _useGlobalUser = useGlobalUser(),
      _useGlobalUser2 = _slicedToArray(_useGlobalUser, 2),
      currentUser = _useGlobalUser2[0],
      setCurrentUser = _useGlobalUser2[1];

  var _React$useState = _react.default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  (0, _useMount.default)(function () {
    if (isUserRequested) {
      setLoading(false);
      return;
    }

    isUserRequested = true; // 优先使用 jiatelin 的 getUserInfo （有防止重发的机制）。如果没有 jiatelin 注入，自行请求用户信息

    var userRequest = window.jtl ? window.jtl.getUserInfo() : getUserInfo();
    userRequest.then(function (res) {
      setLoading(false);
      setCurrentUser(_objectSpread(_objectSpread({}, res.info), {}, {
        avatar: res.info.boardiconurl2
      }));
    }, function (err) {
      setLoading(false);

      if (err.code !== _apiError.EErrorCode.LoginRequired) {
        isUserRequested = false;
        throw err;
      }
    });
  });

  var validateLogin = function validateLogin(opt) {
    var isLoggedIn = !!currentUser;

    if (!isLoggedIn && (opt === null || opt === void 0 ? void 0 : opt.failureRedirect) === true) {
      (0, _login.gotoLogin)();
    }

    return isLoggedIn;
  };

  var withLoginRequired = function withLoginRequired(fn) {
    return function () {
      if (!validateLogin({
        failureRedirect: true
      })) {
        return;
      }

      fn.apply(void 0, arguments);
    };
  };

  return [currentUser, {
    loading: loading,
    validateLogin: validateLogin,
    withLoginRequired: withLoginRequired
  }];
}